import React, { lazy, useContext, useEffect, useState } from 'react';
import loginPool from '../../aws-pool/login-pool';
import { scrollTo } from '../../common';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Common } from '../../common/common';

const ImageLoader = lazy(() => import('../../common/image-loader'));

const SessionExpire = (props) => {
  const [message, setMessage] = useState({
    title: 'Session Timeout',
    subtitle: "We're sorry, but your session has timed out due to inactivity.",
    linkText: "OKAY",
  })

  const location = useLocation();
  const alterHeaderStyle = `<style type="text/css">
    header >.container > button, header >.container > nav{display:none!important;}
    header >.container a.navbar-brand{float:none;margin-left:auto;margin-right:auto;}
  </style>`;

  const handleBrowserBack = () => {
    window.history.pushState(null, '', window.location.href);
  }

  useEffect(() => {
    // console.log('location', location);

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handleBrowserBack);

    // const sessionExpired = sessionStorage.getItem('isSessionExpired')
    const sessionExpired = localStorage.getItem('isSessionExpired')
    
    // if (location.state?.isSessionExpired && sessionExpired === 'true') {
    if (location.state?.isSessionExpired || sessionExpired === 'true') {
      sessionStorage.clear()
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user_guid');
      const user = loginPool.getCurrentUser();
      user && user.signOut();
      // localStorage.clear()

      // Special case to CLOSE the paynow popup and show session expiry screen to user.
      if(location.state?.isSessionExpired && location.state?.fromUrl?.indexOf('/payments') !== -1) {
        window.location.reload();
      }
    } else {
      window.location.href = window.location.origin;
    }

    return () => window.removeEventListener('popstate', handleBrowserBack)
  }, [])

  const onClickRedirect = () => {
    localStorage.clear();
    window.location.href = window.location.origin;
  }

  return (
    <div className="page-error session-expired">
      <div dangerouslySetInnerHTML={{ __html: alterHeaderStyle }}></div>
      <div
        className="error-body session" style={{ backgroundImage: 'url("' + (Common.isValidField(props.data.bannerDetails?.[0].bannerPath) ? props.data.bannerDetails[0].bannerPath : '') + '")' }}
      >
        <div className="mask"></div>
        <div className="c-error">
          <h3>{message.title}</h3>
          <p>{message.subtitle}</p>
          <button
            type="button"
            className="btn btn-light"
            onClick={onClickRedirect}
          >
            {message.linkText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionExpire;